import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { exportRegionTableExcel, loadTableRegion, monitoringModule } from '../MonitoringDucks';
import { useTranslation } from 'react-i18next';
import StaticTablePagination from '../../../_ui/Table/StaticTablePaginated';
import useTableFilter from '../../../components/TableFilter/useTableFilter';
import { queuedByPositionColumn } from './QueuedByPositionColumn';
import Button from '../../../_ui/Button/Button';
import ExportIcon from '@material-ui/icons/SaveAlt';

export default function QueuedByPosition() {
  const dispatch = useDispatch();
  const data = useSelector(state => state[monitoringModule].tableRegionData);
  const loading = useSelector(state => state[monitoringModule].loadingTable);
  const { t } = useTranslation();
  useTableFilter(filter => dispatch(loadTableRegion(filter)));

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <Button
          text={t('monitoring_export_btn')}
          icon={<ExportIcon fontSize="small" className="mr1" />}
          onClick={exportRegionTableExcel}
        />
      </div>
      <StaticTablePagination
        loading={loading}
        sortable={false}
        columns={queuedByPositionColumn({
          t
        })}
        data={data.content}
        totalElements={data.totalElements}
      />
    </div>
  );
}
